/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Sizeofschoolinnumberofstudents6Inputs */

const de__field_sizeofschoolinnumberofstudents6 = /** @type {(inputs: _Field_Sizeofschoolinnumberofstudents6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anzahl der Schüler:innen`)
};

/**

* @param {_Field_Sizeofschoolinnumberofstudents6Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_sizeofschoolinnumberofstudents6 = /** @type {((inputs?: _Field_Sizeofschoolinnumberofstudents6Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Sizeofschoolinnumberofstudents6Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_sizeofschoolinnumberofstudents6(inputs)
});
export { _field_sizeofschoolinnumberofstudents6 as "_field_sizeOfSchoolInNumberOfStudents" }